import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function addOrganizationNftContract(data) {
  const url = `/${ADMIN_PREFIX}/addOrganizationNFTContract`;
  return postApi(url, data);
}
